export default "__VITE_ASSET__e5911f01__"